// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"styles_imageWrapper__1D6ow","imageWrapperError":"styles_imageWrapperError__WFm7x","tooltip":"styles_tooltip__3g77v","thumbImage":"styles_thumbImage__3Cabs"};